import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import createClosePanelEvent from '../control-panel/close-panel-event'
import createOpenCookieBotEvent from '../control-panel/cookie-bot-open'
import createLoginEvent from '../control-panel/login-event'


const STYLES = css`
::slotted(*) {
  font-family: sans-serif; 
  font-style: normal; 
  font-weight: 500; 
  font-size: 14px; 
  line-height: 16px; 
  margin:0; 
  padding:0;
  border:0;
  outline:0;
  vertical-align:baseline;
  background:transparent;
  text-decoration: none;
}

:host {
  display: none;
}

div#WLTR_popBody, div#WLTR_popBody * {
  font-family: sans-serif; font-style: normal; font-weight: 500; font-size: 14px; line-height: 16px; margin:0; padding:0;border:0; outline:0; vertical-align:baseline; background:transparent;text-decoration: none; text-align:left;
}

div#WLTR_popBody {
    position:fixed;
    z-index:99999;
    left: 126px;
    bottom: 0px; 
    width: 288px;
}
 
div#WLTR_popBody:after {
  content: " ";
  display: block;
  background: transparent;
  position:fixed;
  left: 116px;
  bottom: 24px; 
  width: 0; 
  height: 0; 
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent; 
  border-right:10px solid #5900B0;   
}

div#WLTR_popBody div.WLTR_popupMain {
  background: #FFFFFF;
  margin-top: 16px;
  box-shadow: 41px -33px 21px rgba(43, 6, 81, 0.03), 23px -18px 18px rgba(43, 6, 81, 0.11), 10px -8px 13px rgba(43, 6, 81, 0.18), 3px -2px 7px rgba(43, 6, 81, 0.21), 0px 0px 0px rgba(43, 6, 81, 0.21);  
}

div#WLTR_popBody div.WLTR_close {
  position: absolute;  
}

div#WLTR_popBody a#WLTR_closeIcon {
  box-shadow: 41px -33px 21px rgba(43, 6, 81, 0.03), 23px -18px 18px rgba(43, 6, 81, 0.11), 10px -8px 13px rgba(43, 6, 81, 0.18), 3px -2px 7px rgba(43, 6, 81, 0.21), 0px 0px 0px rgba(43, 6, 81, 0.21);  
  background: #5900B0;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: block; 
  color:#FFFFFF; 
  line-height: 82px;
  text-align: center;
  margin-left: auto; 
  margin-right: 25px;
  text-decoration: none;
  position: relative;
  top: -12px;
  left: 274px;
}

div#WLTR_popBody a#WLTR_closeIcon:before {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='17px' viewBox='0 0 24 24' width='17px' fill='%23FFFFFF'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3C/svg%3E");
  vertical-align: middle;
  position: relative;
  top:-26px;
}

div#WLTR_popBody .WLTR_pageInfo {
  height: 80px;
  background: #F6F7F7;
  background-repeat: repeat-x;   
}

div#WLTR_popBody .WLTR_pageInfo img {
  margin: 20px;
  height: 40px;
  width: 40px;
  float: left;
}

div#WLTR_popBody .WLTR_pageInfo h3 {
  font-size: 18px;
  line-height: 32px;
  color: #5900B0;
  padding-top: 10px;
  width: 200px;
  overflow: hidden;
}

div#WLTR_popBody .WLTR_pageInfo .WLTR_partner {
  padding: 1px 8px 1px 8px;
  display: inline-block;
  background: #F7F3FA;
  border: 1px solid #9B66D0;
  border-radius: 100px;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  color: #47008D;  
}

div#WLTR_popBody .WLTR_partnerStyle h3 {
  color: #ffffff;
}

div#WLTR_popBody .WLTR_partnerBackground {
  background-image:var(--background, 'purple');
}

div#WLTR_popBody .WLTR_pageInfo .WLTR_pageScore {
  height: 4px;
  clear: both;
  background: linear-gradient(90deg, #EAE1F3 0%, #5900B0 100%);
  width: 50%;
}

div#WLTR_popBody div.WLTR_settingsInfo {
  padding: 25px 16px 32px 16px;
}

div#WLTR_popBody p, div#WLTR_popBody span {
  font-weight: 400;
  color: #120023;  
  padding-bottom: 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}

div#WLTR_popBody span.WLTR_positive {
  color: #30B56F;
}

div#WLTR_popBody span.WLTR_negative {
  color: #FF1048;
}

div#WLTR_popBody p.WLTR_info {
  font-size: 11px;
  line-height: 16px;
}

div#WLTR_popBody .WLTR_sigleButtonBox{
  text-align:center;
}

div#WLTR_popBody .WLTR_buttonLink {
  color: #ffffff;
  background: #5900B0;
  border-radius: 900px;
  display: inline-block;
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
}

div#WLTR_popBody .WLTR_messageBox {
  padding: 20px 16px 20px 50px;
  background: #FFF4DA;
  margin-bottom: 0px;
  margin-top: 10px;
}

div#WLTR_popBody .WLTR_message {
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  padding-bottom: 16px;
}

div#WLTR_popBody .WLTR_message:before {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 0 24 24' width='24px' fill='%23FFB710'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'/%3E%3C/svg%3E");
  vertical-align: middle;
  color: #FFB710;
  position: absolute;
  left: 28px;
  line-height: 50px;
}

div#WLTR_popBody .WLTR_bottomLinkBox {
  padding: 20px 0 0 0;
}

div#WLTR_popBody .WLTR_bottomLinkBox a {
  font-size: 9px;
  line-height: 14px;
  color: #77797C;
  float: left;
}

div#WLTR_popBody .WLTR_bottomLinkBox a.WLTR_bottomLinkRight {
  float: right;
}

div#WLTR_popBody .WLTR_bottomLinkBox span.WLTR_divider {
  float: right;
  background: #5900B0;
  width: 4px;
  padding: 0;
  margin: 4px 8px 0 8px;
  height: 4px;
  border-radius: 50%;
}

div#WLTR_popBody .WLTR_bottomBox {
  background: #F4F4F4;
  padding: 12px 16px 18px 12px;
}

div#WLTR_popBody .WLTR_profileBox {
  padding-top: 4px;
}

div#WLTR_popBody .WLTR_bottomBox a.WLTR_profileLink {
  color: #DBFEC5;
  background: #5900B0;
  border-radius: 9000px;
  font-size: 14px;
  line-height: 16px;
  padding: 3px 6px 2px 6px;
  text-transform: uppercase;
}

div#WLTR_popBody .WLTR_bottomBox a.WLTR_profileLinkIcon:after {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='18px' viewBox='0 0 24 24' width='18px' fill='%23000000'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z'/%3E%3C/svg%3E");
  vertical-align: middle;
  padding-left: 1px;
  color: #000;
  position: relative;
  top: 2px;
}

div#WLTR_popBody .WLTR_bottomBox a.WLTR_loginLink {
  color: #4C3D5A;
  background: #FFFFFF;
  border-radius: 900px;
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.02em;
  padding: 9px 11px 9px 8px;  
}

div#WLTR_popBody .WLTR_bottomBox a.WLTR_loginLink:before {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 -960 960 960' width='24'%3E%3Cpath fill='%235900B0' d='M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z'/%3E%3C/svg%3E");
  vertical-align: middle;
  font-size: 24px;
  position: relative;
  left: -4px;
}

div#WLTR_popBody .WLTR_bottomBox div.WLTR_bottomLogo {
  height: 24px;  
  width: 104px;
  float: right;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPzSURBVHgB5VdNUlpBEP7mgVZ0E3MCnycQT5DH2oo+Nil1I55APIF4AskJJBs1yQLIBcQTBE+QlxOoG42UMPl6fnBAMMbSKqvSVVPz6Onp/+5pFF4prKGRyP4b6DRRuvC/j1Fq4xkhj1cKCupE9llMxTR+zv82R88IEf5zyK+haTwbYaoMdN9pqH3+TOjmeh96jymXfUQjzUPtaqAg+CvonRlEqxqad/QpaarCg5GKGaBdejUl7RxXm5GrH2H1sztP5Jw8OkdId0aV8bocIy163C26SzneGaUR6FGPbyh1RC7lbBOVCp5ys1CuwDqa+1Z/3aIO8/JtHEBlEk9E4xvcYsekTEJJv60I6kAM8vg3iDLukosJ72TeeNL9cIYbsLx1wrMF56TY3hkPoS4eIiu3MI4mj9zbDTR4pk68fo4mFrk0unINXZQeAhs83lWJo3E8BiDRj+r2ULUZXVH0gh5DH6oW4nlZHBAPKz9wUodqVxR6l7BZUuXZLp3QxhMgMvxUhXxqTlLZn2n0qIoJmpFLOVUG5IL4BQbDRHzGZs9QtvnM5N0scMD0+TGW9wK60+D7Hn4Nrd2QKVO6SCPL/GwfYyVzaKZnU6JepkBxxhn+GabP++i2lAtCmNZOXsyV2UinF15HnmWucVZSNEL9O2GJPWsTZJrXpWcMY7VxWJiizwU0cFN2yVCX5qEubWWyB5B+FdyqhXRjn8Eyn50b1jOCNJeG8xWlGiaAa0QHFFp4CWMfgojlwXq/p5t+xN2Jc4AKmpkVohYn0TrjJd3ixwh9TTC2BOomne5Shc7gb703iYl7gmKurI8cu+1U7BdxTbwwsAQqoczRdY1+a9LdyBonTLoL4cE0+p/8d880tuHaZtrFsst9n/JSi1/w4ewQy79kkae8NoWAT8fdKbAxDZWJH3Xh9AnhTYCzs8YADL8cdMHLDGVr3Cayj/aHYTvunrgDz1yU6wLVgIhvamszUKJs5wRz2vRO5JOZhgb5svA4GVoc7dysHbgGRol8+dZjMsZmJNpOz4bXU5uhxs4mxFU9fWpHZz6Puh6M0GMhL5G+sW+rKPGTzSRz9e8jlFkjdH3DNZrgrHaElVMOI5fapCES0pxra2Q8TiCV3pK3W5QmbTpCm00qNbnnBq2C1/MWujRl3n47a5DfdshPnM1ptogHIBLvkkFRi6MtxM7AjJ2/xPddSmNguCzLWFX8OHvIyPK0BDsgzeFumuTgpKqhwCOUmpNpdfH+M2pB8DRmCS7t5Z5MgodY3bNOvc8PD/DzMPTPyqZibl6mOGvUHUhazSC3KGdXFDaprtbx/f3faDzIGKtpBGVmUrd4JHg9r9E7C2U8hd8f1Zi+21RQ0PkAAAAASUVORK5CYII=');
  background-repeat: no-repeat;  
  font-size: 7px;
  font-weight: 500;
  line-height: 55px;
  letter-spacing: 0.05em;
  text-align: right;
  color: #77797C;
  text-transform: uppercase;
  background-position: top right;
}

div#WLTR_popBody .WLTR_meetWaulterHeader {
  height: 40px;
  padding: 16px;
  background: #d2ffc0;
  background-image: url('data:image/png;base64,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');
  background-repeat: no-repeat;
  background-size: 100%;  
  cursor: pointer;
}

div#WLTR_popBody .WLTR_meetWaulterHeader h3 {
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;  
  color: #5900B0;
}

div#WLTR_popBody .WLTR_meetWaulterHeader h3:before {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 0 24 24' width='24px' fill='%235900B0'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z'/%3E%3C/svg%3E");
  vertical-align: middle;
  padding: 6px 8px 5px 8px;
  border: 1px solid #5900B0;
  border-radius: 100px;
  float: right;
}

div#WLTR_popBody .WLTR_meetWCollapsed h3:before {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 0 24 24' width='24px' fill='%235900B0'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'/%3E%3C/svg%3E");
  padding: 8px 8px 3px 8px;
}

div#WLTR_popBody .WLTR_settingsInfo ul {
  list-style: none;
  padding: 0px 0px 10px 0px;
}

div#WLTR_popBody .WLTR_settingsInfo ul li {
  margin-bottom: 12px;
  padding-left: 25px;
  font-size: 11px;
  line-height: 16px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFfSURBVHgBnZNPTsJQEMa/eaBRdIE3KAsW7sAdJibWC8gNjCcg8QKVG7By6xW6cycSY1xaVyS6aHfutAtR/pSO8wpVWkELX9L0dd78ZiaTr4SUnvn2EMgdM7hODEPHGHAUw8kp1SxRzZvNp/jg8kNxHH6cM6GBv0TceseoWSXT/y6g4YA/29KrggzSE/VoaOoiSgd056zwtGtlG2tWdHb53gg4dLGKKDTVGKGVJbfvM3xvnIixLFsx49/R3wS82HuF2xklL5jrege/CnTtQQK+PPJRPdmUZyORJ7sw8pgz6tVZDy+PQQTEsGkVME/0xHdubJifrmEE9v0QtUZhISxmcxSB7PTFjqFwel0UcGshPKlADkXWZdXGCgpoWFJlOrgBUQtLioXZJdOLnJjHoCkvJzOsrTxhEBUoiafz4u0sk+jO8X+gvymd0OW2kcO6RRODVaYdPSluS7Jdpv3ObP4X20KVlmSNI6QAAAAASUVORK5CYII=');
  background-repeat: no-repeat;
}

div#WLTR_popBody .WLTR_meetWaulter div.WLTR_sigleButtonBox {
  background: #EAE1F380;
  padding: 15px 0 15px 0;
}

div#WLTR_popBody .WLTR_meetWaulter div.WLTR_settingsInfo {
  padding: 16px ;
}

@media all and (max-width: 449px) {
  :host, div#WLTR_popBody {
    left: 0px;
    bottom: 0px; 
    width: 100%;
  }  
  div#WLTR_popBody div.WLTR_close {
    right: 0;
  }
  div#WLTR_popBody a#WLTR_closeIcon {
    left: 25px;
  }
  div#WLTR_popBody::after {
    display: none;
  }
}

div#WLTR_popBody .WLTR_meetWBodyHide {
  display: none
}

`
@customElement('cp-control-panel')
export class ControlPanelElement extends LitElement {
    static styles = STYLES

    private _url: Optional<String> = ''
    private _decision: Optional<String> = '' 
    private _scoreValue: Optional<BigInt> = ''
    private _linkCookies: Optional<String> = '' 
    private _linkPrivacy: Optional<String> = '' 
    private _partner: Optional<boolean> = false
    private _cb: Optional<boolean> = false
    private _logo: Optional<string> = ''
    private _background: Optional<string> = ''
    private _name: Optional<string> = ''
    private _userPreferenceRatings: Optional<string> = ''
    private _alertText: Optional<string> = ''
    private _alertCtaText: Optional<string> = ''
    private _alertCtaLink: Optional<string> = ''
    private _userInitials: Optional<string> = ''
    private _stateMeetWauter: boolean = true;
    private _meetWaulter: string = 'false';

    @property()
    get url() {
        return this._url
    }

    set url(value: Optional<String>) {
        this._url = value
    }

    @property()
    get decision(){
        return this._decision
    }

    set decision(value: Optional<String>){
      this._decision = value
      this.requestUpdate()
    }

    @property()
    get scoreValue() {
        return this._scoreValue
    }

    set scoreValue(value: Optional<BigInt>) {
        this._scoreValue = value
    }

    @property()
    get linkCookies() {
        return this._linkCookies
    }
    set linkCookies(value: Optional<String>) {
        this._linkCookies = value
    }

    @property()
    get linkPrivacy() {
        return this._linkPrivacy
    }
    set linkPrivacy(value: Optional<String>) {
        this._linkPrivacy = value
    }

    @property()
    get partner() {
        return this._partner
    }
    set partner(value: Optional<boolean>) {
        this._partner = value
    }

    @property()
    get cb() {
        return this._cb
    }
    set cb(value: Optional<boolean>) {
        this._cb = value
    }

    @property()
    get logo() {
        return this._logo
    }
    set logo(value: Optional<string>) {
        this._logo = value
    }

    @property()
    get background() {
        return this._background
    }
    set background(value: Optional<string>) {
        this._background = value
    }

    @property()
    get name() {
        return this._name
    }
    set name(value: Optional<string>) {
        this._name = value
    }

    @property()
    get userPreferenceRatings() {
        return this._userPreferenceRatings
    }
    set userPreferenceRatings(value: Optional<string>) {
        this._userPreferenceRatings = value
    }

    @property()
    get alertText() {
        return this._alertText
    }
    set alertText(value: Optional<string>) {
        this._alertText = value
        this.requestUpdate()
    }

    @property()
    get alertCtaText() {
        return this._alertCtaText
    }
    set alertCtaText(value: Optional<string>) {
        this._alertCtaText = value
        this.requestUpdate()
    }

    @property()
    get alertCtaLink() {
        return this._alertCtaLink
    }
    set alertCtaLink(value: Optional<string>) {
        this._alertCtaLink = value
        this.requestUpdate()
    }


    @property()
    get userInitials() {
        return this._userInitials
    }
    set userInitials(value: Optional<string>) {
        this._userInitials = value
    }

    @property()
    get meetWaulter() {
        return this._meetWaulter
    }
    set meetWaulter(value: string) {
        this._meetWaulter = value
        this.requestUpdate()
    }
    
    connectedCallback() {
      super.connectedCallback();
      this.style.setProperty(
        '--background',
        "url('"+this._background+"')"
      );
    }
    
    protected render() {
        return html`
        <div id="WLTR_popBody">
          <div class="WLTR_popupMain">
            <div class="WLTR_close"><a id="WLTR_closeIcon" href="#" @click="${this._onClick}"></a></div>
            <div class="WLTR_pageInfo ${ this._partner ? "WLTR_partnerStyle":""} ${ this._background !== '' ? "WLTR_partnerBackground":""}" ${ this._background !== '' ? "WLTR_partnerBackground":""}>
                <img src="${ this._logo != '' ? this._logo : "data:image/png;base64,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"}" />
                <a href="${ this._userInitials !== '' ? `https://my.waulter.cz/web/${this._url}/detail`:`https://waulter.eu/web.html?url=${this._url}`}" target="_blank"><h3>${this.name !== '' ? this._name : this._url}</h3></a>
                ${ this._partner? html`<div class="WLTR_partner">Partner</div>`: null }  
                <div class="WLTR_pageScore" style="width:${this._scoreValue}%;"></div>
            </div>
            <div class="WLTR_settingsInfo">
                <p>S ${ this._url} ${ this._decision === "mixed" ?  html`<span class='WLTR_positive'>sdílíš informace</span>`
                                                              : html`<span class='WLTR_negative'>nesdílíš informace</span>` }</p>
                
                ${
                    this._partner ?
                    html `${this._decision === "mixed" ? html`<p class="WLTR_info">${this._userPreferenceRatings}</p>` : ""}
                          <div class="WLTR_sigleButtonBox">
                          ${ this._cb && this._userInitials === '' ? 
                              html `<a href="#" class="WLTR_buttonLink" @click="${ this._onClickOpenCookieBot }">Nastavit soukromí</a>` :
                              html `<a href="https://my.waulter.cz" target="_blank" class="WLTR_buttonLink">Nastavit v administraci</a>` } 
                          </div>`: null
                }
                ${
                    this._alertText !== '' ?
                    html`<div class="WLTR_messageBox">
                          <p class="WLTR_message">${ this._alertText }</p>
                          ${ this._alertCtaText !== '' ? html`<a href="${ this._alertCtaLink}" class="WLTR_buttonLink" target="_blank">${ this._alertCtaText }</a>`: "" }
                          </div>`
                    : (
                      this._cb && !this._partner ?
                      html `<a href="#" class="WLTR_buttonLink" @click="${ this._onClickOpenCookieBot }">Nastavit soukromí 2</a>`
                      : null
                    )
                }
                

                <div class="WLTR_bottomLinkBox">
                ${ this._linkCookies !== '' ?
                    html`<a href="https://${this._linkCookies}" class="WLTR_bottomLinkRight" target="_blank">Cookies</a><span class="WLTR_divider"></span>`
                    : null
                }  
                ${ this._linkPrivacy !== '' ?
                    html`<a href="https://${this._linkPrivacy}" class="WLTR_bottomLinkRight" target="_blank">Zpracování osobních údajů</a>`
                    : null
                }  
                <a href="https://my.waulter.cz/web/${this._url}/detail" target="_blank">Co o mě stránka ví</a>
                </div>
            </div>
            <div class="WLTR_bottomBox">
                ${ 
                  this._userInitials !== '' ?
                  html`<div class="WLTR_bottomLogo">Vaše soukromí je vaše</div>
                  <div class="WLTR_profileBox">
                    <a href="https://my.waulter.cz" class="WLTR_profileLink" target="_blank">${this._userInitials}</a>
                    <a href="https://my.waulter.cz" class="WLTR_profileLinkIcon" target="_blank"></a>
                  </div>`:
      
                  html`<div class="WLTR_bottomLogo">Vaše soukromí je vaše</div>
                  <a href="#" class="WLTR_loginLink" @click="${this._onClickLogin}">Přihlásit</a>
                  <div id="WLTR_arrow"><div>`
      
                }
            </div>
          </div>
          ${  this._meetWaulter === "false" ? "" :
              html`<div class="WLTR_popupMain WLTR_meetWaulter">
                    <div class="WLTR_meetWaulterHeader ${ this._stateMeetWauter ? "": "WLTR_meetWCollapsed"}" @click="${this._closeMeetWaulter}">
                      <h3>Seznamte se<br />s Waulterem</h3>
                    </div>
                    <div id="WLTR_meetWBody" class="WLTR_settingsInfo ${ this._stateMeetWauter === false ? "WLTR_meetWBodyHide": ""}">
                      <p class="WLTR_info">Musíme se vás zeptat, jaké nastavení za vás máme nastavit.</p>
                      <ul>
                        <li>Můžete mi dát dva různé úkoly</li>
                        <li>Hlídat vaše maximální soukromí</li>
                        <li>Můžete mi dát dva různé úkoly${this._meetWaulter}</li>
                      </ul>
                      <div class="WLTR_sigleButtonBox">
                        <a href="https://my.waulter.cz?isSignup=1" class="WLTR_buttonLink" target="_blank">Založit účet</a>
                      </div>
                    </div>
                  </div>`
          
          }
        <slot></slot>
        </div>
        `;
    }

    private _onClick(_: Event) {
      const event = createClosePanelEvent()

      this.dispatchEvent(event)
    }

    private _onClickOpenCookieBot() {
      const event = createOpenCookieBotEvent()

      this.dispatchEvent(event)
    }

    
    private _closeMeetWaulter()
    {
      //toggleStuff('WLTR_meetWBody');toggleClass(this, 'WLTR_meetWCollapsed');
      this._stateMeetWauter = !this._stateMeetWauter;
      this.requestUpdate();
    }

    private _onClickLogin(_: Event) {
      const event = createLoginEvent()
      this.dispatchEvent(event)
  }
}


